<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <Platform
      :visible.sync="editPlatform.visible"
      :disabled="editPlatform.disabled"
      :title="editPlatform.title"
      :platformCode="editPlatform.platformCode"
      :pageType="editPlatform.pageType"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import Platform from '../../detail'

export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, Platform },
  data() {
    return {
      usePage: true,
      editPlatform: {
        visible: false,
        platformCode: '',
        pageType: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgPlatformListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, code = '' }) {
      const types = {
        add: this.$l('dialog_title_add') || '新增渠道',
        edit: this.$l('dialog_title_edit') || '编辑渠道',
        detail: this.$l('dialog_title_detail') || '渠道详情',
        review: this.$l('dialog_title_review_edit') || '渠道审核修改',
      }
      this.editPlatform = {
        visible: true,
        title: types[pageType],
        platformCode: code,
        pageType,
        disabled: pageType === 'detail',
      }
    },
  },
}
</script>
